import React from "react";
import ReactDOM from "react-dom/client";
import "../node_modules/font-awesome/css/font-awesome.min.css";
import '@fortawesome/fontawesome-free/css/all.min.css';
import '@fortawesome/fontawesome-free/css/fontawesome.min.css';
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Provider } from "react-redux";
import { PersistGate } from 'redux-persist/integration/react';
import store, { persistor } from "./redux/store";

import {
  Home,
  AboutPage,
  TermsPage,
  PrivacyPage,
  RefundPage,
  ContactPage,
  Cart,
  Login,
  ForgotPassword,
  ResetPassword,
  Register,
  Checkout,
  PageNotFound,
  Courses,
  CourseDetail,
  QrReader,
  RegisterOtp,
  Follower,
  LogOut,
} from "./pages";
import Teacher from "../src/pages/Teacher/Teacher"
import Studentdashboard from "../src/pages/Student/StudentDashboard"
import {AdminLogin,AdminDashboard,CreateVideo}  from "./components/admin";
import {CreateRole,EditRole,ListRole}  from "./components/admin/role";
import {CreateCourse,EditCourse,ListCourse}  from "./components/admin/course";
import {CreateInstitute,EditInstitute,ListInstitute}  from "./components/admin/institute";
import ScrollToTop from "./components/ScrollToTop";
import { Toaster } from "react-hot-toast";
import OtpPage from "./pages/OtpPage";
import Feed from "./pages/Feed";
import FeedDetail from "./pages/FeedDetail";
import CourseVideo from "./pages/CourseVideo";
import Learn from "./pages/Learn";
import CourseCart from "./pages/CourseCart";
import CourseCheckout from './pages/CourseCheckout'
import Upload from "./pages/Upload";
import UploadMedia from "./pages/UploadMedia";
import StudentProfileCourse from './pages/Student/StudentProfileCourse'
import DashboardPost from "./pages/Student/DashboardPost";
import DashboardPostDetail from "./pages/Student/DashboardPostDetail";
import StudentOrderAssign from "./pages/Student/StudentOrderAssign";
import DashboardChat from "./pages/DashboardChat";
import DashboardChatBox from "./pages/DashboardChatBox";
import StudentCertificate from "./pages/Student/StudentCertificate";
import StudentCertificateDetail from "./pages/Student/StudentCertificateDetail";
import TeacherChenal from "./pages/Teacher/TeacherChenal";
import TeacherCourse from "./pages/Teacher/TeacherCourse";
import TeacherChannelBoost from './pages/Teacher/TeacherChannelBoost'
import TeacherProfile from "./pages/Teacher/TeacherProfile";
import StudentChatList from "./pages/Student/StudentChatList";
import StudentChatbot from "./pages/Student/StudentChatbot";
import StudentChatListRemove from "./pages/Student/StudentChatListRemove";
import StudentProfileHistory from "./pages/Student/StudentProfileHistory";
import TeacherChannelBoost1 from "./pages/Teacher/TeacherChannelBoost1";
import TeacherChannelBoost2 from "./pages/Teacher/TeacherChannelBoost2";
import StudentProfile from "./pages/Student/StudentProfile";
import InstituteProfile from "./pages/Institute/InstituteProfile";
import Institute from './pages/Institute/Institute'
import Studyabroad from './pages/StudyAbroad/StudyAbroad'
import InstituteDetail from './pages/Institute/InstituteDetail'
import TeacherHistory from "./pages/Teacher/TeacherHistory";
import TeacherOrderAssign from "./pages/Teacher/TeacherOrderAssign";
import CollageProfile from "./pages/Cologe/CollageProfile";
import Collage from "./pages/Cologe/Collage";
import CollegeDetail from "./pages/Cologe/CollegeDetail";
import TeacherDetail from "./pages/Teacher/TeacherDetail";
import InstituteCourse from "./pages/Institute/InstituteCourse";
import InstituteChennal from "./pages/Institute/InstituteChannel";
import CourseStructure from "./pages/Institute/CourseStructure";
import CourseCircullam from './pages/Institute/InstituteCurriculum'
import InstituteCaption from './pages/Institute/InstituteCaption'
import InstitutePromotion from "./pages/Institute/InstititePromotion";
import InstituteWelcome from "./pages/Institute/InstituteWelcome";
import InstituteInfo from "./pages/Institute/InstituteInfo";
import InstituteAbout from "./pages/Institute/InstituteAbout";
import InstitutePosts from "./pages/Institute/InstitutePosts";
import InstitutePost from "./pages/Institute/InstitutePost";
import InstituteVIdeoList from "./pages/Institute/InstituteVIdeoList";
import InstituteCourseList from "./pages/Institute/InstituteCourseList";
import { CompetitiveListRole, CompetitiveRole, EditCompetitiveRole } from "./components/admin/competitive";
import CompetitiveCreateRole from "./components/admin/competitive/CompetitiveCreateRole";
import { EditinstituteLobo, InstituteLoboCreate, InstituteLoboList } from "./components/admin/instituteLobo";
import { EditLatestNews, LatestNewsCreate, LatestNewsList } from "./components/admin/LatestNews";
import {  EnquiriesList } from "./components/admin/enquiries";
import { AnnoucementList, CreateAnnoucement, EditAnnoucement } from "./components/admin/Annoucement";
import { AchievementList, CreateAchievement, EditAchievement } from "./components/admin/Achievement";
import { CreateWallofFame, EditWallofFame, WallofFameList } from "./components/admin/WallofFame";
import { CreateMostPreffered, EditMostPreffered, MostPrefferedList } from "./components/admin/MostPrefferedTestSeries";
import { CreateSolvedPaper, EditSolvedPaper, SolvedPaperList } from "./components/admin/PreviousSolvedPaper";
import { CreateStudentExperience, EditStudentExperience, StudentExperienceList } from "./components/admin/StudentExperiences";
import InstituteEditChennal from "./pages/Institute/InstituteEditChannel";
import { CreateExamPreparation, EditExamPreparation, ExamPreparationList } from "./components/admin/ExamPrepration";
import { CreateExamPaperPreparation, EditExamPaperPreparation, ExamPaperPreparationist } from "./components/admin/ExamPaperPrepration";
import { ClassModalList, CreateClassModal, EditClassModal } from "./components/admin/classmodal";
import { EditTopExplore, TopExploreCreate, TopExploreList } from "./components/admin/TopExplore";
import { CreateSubscription, EditSubscription, SubscriptionList } from "./components/admin/Subscription";
import Examdetail from "./pages/Examdetail";
import { CreateExamdetailOverView, EditExamdetailOverView, ExamdetailOverViewList } from "./components/admin/ExamdetailOverView";
import { CreateExamPaperdetailInfo, EditExamPaperdetailInfo, ExamPaperdetailInfoList } from "./components/admin/ExamPaperdetailInfo";
import { CreateExamDetailTestSeries, EditExamDetailTestSeries, ExamDetailTestSeriesList } from "./components/admin/ExamDetailTestSeries";
import { CreateExamDetailDescription, EditExamDetailDescription, ExamDetailDescriptionList } from "./components/admin/ExamDetailDescription";
import PrevPaper from "./pages/PrevPaper";


const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <ScrollToTop>
      <Provider store={store}>
        <Routes>
          <Route exact path="/" element={<Home />} />
          <Route path="/teacher" element={<Teacher />} />
          <Route path="/TeacherDetail/:id" element={<TeacherDetail />} />
          <Route path="/course" element={<Courses />} />
          <Route path="/Feed" element={<Feed />} />
          <Route path="/examdetail/:id" element={<Examdetail />} />
          <Route path="/prevPaper/:id" element={<PrevPaper />} />
          <Route path="/Learn" element={<Learn />} />
          <Route path="/coursecart" element={<CourseCart />} />
          <Route path="/CourseCheckout" element={<CourseCheckout />} />
          <Route path="/Upload" element={<Upload />} />
          <Route path="/UploadMedia" element={<UploadMedia />} />
          <Route path="/CourseVideo" element={<CourseVideo />} />
          <Route path="/CourseDetail/:id" element={<CourseDetail />} />
          <Route path="/feeddetail/:id" element={<FeedDetail />} />
          <Route path="/studentdashboard" element={<Studentdashboard />} />
          <Route path="/institute" element={<Institute />} />
          <Route path="/Studyabroad" element={<Studyabroad />} />
          <Route path="/InstituteWelcome" element={<InstituteWelcome/>} />
          <Route path="/InstitutePromotion" element={<InstitutePromotion/>} />
          <Route path="/InstituteCaption" element={<InstituteCaption/>} />
          <Route path="/CourseCircullam" element={<CourseCircullam/>} />
          <Route path="/CourseStructure" element={<CourseStructure/>} />
          <Route path="/instituteChennal" element={<InstituteChennal/>} />
          <Route path="/InstituteEditChennal/:id" element={<InstituteEditChennal/>} />
          <Route path="/instituteCourse" element={<InstituteCourse/>} />
          <Route path="/InstituteDetail/:id" element={<InstituteDetail />} />
          <Route path="/InstituteInfo/:id" element={<InstituteInfo />} />
          <Route path="/InstituteAbout/:id" element={<InstituteAbout />} />
          <Route path="/InstitutePosts/:id" element={<InstitutePosts />} />
          <Route path="/InstitutePost/:id" element={<InstitutePost />} />
          <Route path="/InstituteVIdeoList/:id" element={<InstituteVIdeoList />} />
          <Route path="/InstituteCourseList/:id" element={<InstituteCourseList />} />
          {/* <Route path="/InstituteDetail/:id" element={<InstituteDetail />} /> */}
          <Route path="/collage" element={<Collage />} />
          <Route path="/CollegeDetail/:id" element={<CollegeDetail />} />
          <Route path="/collageProfile/:id/:flags" element={<CollageProfile />} />
          <Route path="/instituteProfile/:id/:flags" element={<InstituteProfile />} />
          <Route path="/DashboardChat" element={<DashboardChat />} />
          <Route path="/TeacherProfile/:id/:flags" element={<TeacherProfile />} />
          <Route path="/teacherChannelBoost" element={<TeacherChannelBoost />} />
          <Route path="/teacherChannelBoost1" element={<TeacherChannelBoost1 />} />
          <Route path="/teacherChannelBoost2" element={<TeacherChannelBoost2 />} />
          <Route path="/TeacherCourse" element={<TeacherCourse />} />
          <Route path="/TeacherChenal" element={<TeacherChenal />} />
          <Route path="/TeacherHistory" element={<TeacherHistory />} />
          <Route path="/TeacherOrderAssign" element={<TeacherOrderAssign />} />
          <Route path="/studentChatList" element={<StudentChatList />} />
          <Route path="/studentChatbot" element={<StudentChatbot />} />
          <Route path="/studentProfile" element={<StudentProfile />} />
          <Route path="/studentProfileHistory" element={<StudentProfileHistory />} />
          <Route path="/studentChatListRemove" element={<StudentChatListRemove />} />
          <Route path="/StudentCertificateDetail" element={<StudentCertificateDetail />} />
          <Route path="/StudentCertificate" element={<StudentCertificate />} />
          <Route path="/DashboardChatBox" element={<DashboardChatBox />} />
          <Route path="/StudentOrderAssign" element={<StudentOrderAssign />} />
          <Route path="/DashboardPost" element={<DashboardPost />} />
          <Route path="/dashboardPostDetail/:id" element={<DashboardPostDetail />} />
          <Route path="/StudentProfileCourse" element={<StudentProfileCourse />} />
          <Route path="/OtpPage" element={<OtpPage />} />
          <Route path="/RegisterOtp" element={<RegisterOtp />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/refund" element={<RefundPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/cart" element={<Cart />} />
          <Route path="/login" element={<Login />} />
          <Route path="/forgotpassword" element={<ForgotPassword />} />
          <Route path="/resetpassword" element={<ResetPassword />} />
          <Route path="/logOut" element={<LogOut />} />
          <Route path="/register" element={<Register />} />
          <Route path="/registerOtp" element={<RegisterOtp />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/follower" element={<Follower />} />
          <Route path="*" element={<PageNotFound />} />
          <Route path="/product/*" element={<PageNotFound />} />
          <Route path="/qrReader/*" element={<QrReader />} />


          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          {/* Role route for admin */}
          <Route path="/admin/createRole" element={<CreateRole />} />
          <Route path="/admin/editRole/:id" element={<EditRole />} />
          <Route path="/admin/listRole" element={<ListRole />} />
          <Route path="/admin/competitiveListRole" element={<CompetitiveListRole />} />
          <Route path="/admin/editCompetitiveRole/:id" element={<EditCompetitiveRole />} />
          <Route path="/admin/competitiveCreateRole" element={<CompetitiveCreateRole />} />
          <Route path="/admin/editinstituteLobo/:id" element={<EditinstituteLobo />} />
          <Route path="/admin/instituteLoboList" element={<InstituteLoboList />} />
          <Route path="/admin/instituteLoboCreate" element={<InstituteLoboCreate />} />
          <Route path="/admin/enquiries" element={< EnquiriesList/>} />
          {/* Course route for admin */}
          <Route path="/admin/createCourse" element={<CreateCourse />} />
          <Route path="/admin/editCourse/:id" element={<EditCourse />} />
          <Route path="/admin/listCourse" element={<ListCourse />} />

          {/* Institute route for admin */}
          <Route path="/admin/createInstitute" element={<CreateInstitute />} />
          <Route path="/admin/editInstitute/:id" element={<EditInstitute />} />
          <Route path="/admin/listInstitute" element={<ListInstitute />} />
          <Route path="/admin/editLatestNews/:id" element={<EditLatestNews />} />
          <Route path="/admin/latestNewsList" element={<LatestNewsList />} />
          <Route path="/admin/latestNewsCreate" element={<LatestNewsCreate />} />
          
          <Route path="/admin/createvideo" element={<CreateVideo />} />

          {/* Exam route for admin */}

          <Route path="/admin/editAnnoucement/:id" element={<EditAnnoucement />} />
          <Route path="/admin/annoucementList" element={<AnnoucementList />} />
          <Route path="/admin/createAnnoucement" element={<CreateAnnoucement />} />

          <Route path="/admin/editAchievement/:id" element={<EditAchievement />} />
          <Route path="/admin/achievementList" element={<AchievementList />} />
          <Route path="/admin/createAchievement" element={<CreateAchievement />} />
         

          <Route path="/admin/editWallofFame/:id" element={<EditWallofFame />} />
          <Route path="/admin/wallofFameList" element={<WallofFameList/>} />
          <Route path="/admin/createWallofFame" element={<CreateWallofFame />} />


          <Route path="/admin/editMostPreffered/:id" element={<EditMostPreffered />} />
          <Route path="/admin/mostPrefferedList" element={<MostPrefferedList/>} />
          <Route path="/admin/createMostPreffered" element={<CreateMostPreffered />} />


          <Route path="/admin/editSolvedPaper/:id" element={<EditSolvedPaper />} />
          <Route path="/admin/solvedPaperList" element={<SolvedPaperList/>} />
          <Route path="/admin/createSolvedPaper" element={<CreateSolvedPaper />} />

          <Route path="/admin/editStudentExperience/:id" element={<EditStudentExperience/>} />
          <Route path="/admin/studentExperienceList" element={<StudentExperienceList/>} />
          <Route path="/admin/createStudentExperience" element={<CreateStudentExperience/>} />

          <Route path="/admin/createExamPreparation" element={<CreateExamPreparation />} />
          <Route path="/admin/examPreparationList" element={<ExamPreparationList />} />
          <Route path="/admin/editExamPreparation/:id" element={<EditExamPreparation />} />

          <Route path="/admin/createExamPaperPreparation" element={<CreateExamPaperPreparation />} />
          <Route path="/admin/examPaperPreparationist" element={<ExamPaperPreparationist />} />
          <Route path="/admin/editExamPaperPreparation/:id" element={<EditExamPaperPreparation />} />


          <Route path="/admin/createClassModal" element={<CreateClassModal />} />
          <Route path="/admin/classModalList" element={<ClassModalList />} />
          <Route path="/admin/editClassModal/:id" element={<EditClassModal />} />


          <Route path="/admin/createSubscription" element={<CreateSubscription />} />
          <Route path="/admin/subscriptionList" element={<SubscriptionList />} />
          <Route path="/admin/editSubscription/:id" element={<EditSubscription />} />

          <Route path="/admin/topExploreCreate" element={<TopExploreCreate />} />
          <Route path="/admin/topExploreList" element={<TopExploreList />} />
          <Route path="/admin/editTopExplore/:id" element={<EditTopExplore />} />

          <Route path="/admin/createExamdetailOverView" element={<CreateExamdetailOverView />} />
          <Route path="/admin/examdetailOverViewList" element={<ExamdetailOverViewList />} />
          <Route path="/admin/editExamdetailOverView/:id" element={<EditExamdetailOverView />} />

          <Route path="/admin/createExamPaperdetailInfo" element={<CreateExamPaperdetailInfo />} />
          <Route path="/admin/examPaperdetailInfoList" element={<ExamPaperdetailInfoList />} />
          <Route path="/admin/editExamPaperdetailInfo/:id" element={<EditExamPaperdetailInfo />} />

          <Route path="/admin/createExamDetailTestSeries" element={<CreateExamDetailTestSeries />} />
          <Route path="/admin/examDetailTestSeriesList" element={<ExamDetailTestSeriesList/>} />
          <Route path="/admin/editExamDetailTestSeries/:id" element={<EditExamDetailTestSeries />} />

 

          <Route path="/admin/createExamDetailDescription" element={<CreateExamDetailDescription />} />
          <Route path="/admin/examDetailDescriptionList" element={<ExamDetailDescriptionList/>} />
          <Route path="/admin/editExamDetailDescription/:id" element={<EditExamDetailDescription />} />


         

         
        </Routes>
      </Provider>
    </ScrollToTop>
    <Toaster />
  </BrowserRouter>
);
